import Link from "next/link";
import dynamic from "next/dynamic";
import { NewContainer } from "../NewContainer";

export const CallToAction = () => {
  return (
    <section className="relative overflow-hidden py-[120px] px-6 lg:px-10 bg-blue-primary-900 text-white text-center">
      {/* Background radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[radial-gradient(circle,rgba(0,56,112,0.5),transparent_70%)]" />

      <div className="relative z-10 max-w-[740px] mx-auto fade-in">
        <h2 className="font-inter text-[36px] sm:text-[42px] lg:text-[56px] font-extrabold tracking-[-1.5px] leading-[1.15] mb-5">
          AI speed. Human trust. Your growth.
        </h2>
        <p className="font-inter text-[18px] text-white/80 leading-[1.7] mb-10">
          Join hundreds of Australian businesses who use Ledgerowl&apos;s
          AI-powered, human-verified accounting to keep their books flawless,
          their BAS lodged, and their growth on track.
        </p>
        <div className="flex justify-center gap-4 flex-wrap">
          <Link
            href="/contact"
            className="inline-flex items-center gap-2 bg-blue-primary-500 hover:bg-[#005bb5] text-white px-9 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,116,230,0.35)]"
          >
            Book a Demo
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </Link>
          <Link
            href="/contact"
            className="inline-flex items-center bg-transparent text-white px-9 py-4 rounded-full text-base font-medium border-[1.5px] border-white/50 transition-all duration-300 hover:border-white hover:bg-white/5"
          >
            Get Started
          </Link>
        </div>
        <p className="text-[13px] text-white/60 mt-5">
          14-Day Free Trial · No Commitment Required
        </p>
      </div>
    </section>
  );
};
